const adminApi = async ({ url, method = 'GET', body, toFormData = false }) => {
  const headers = {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  };

  if (!toFormData) {
    headers['Content-Type'] = 'application/json';
  }

  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL_ADMIN}${url}`, {
      method: method,
      headers: headers,
      body: toFormData ? body : JSON.stringify(body),
    });

    if (res.status === 401) {
      alert('The session has expired, please log in again.');
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      window.location.href = '/login';
      return;
    }

    return res;
  } catch (error) {
    console.error('Error during API call:', error);
    throw error;
  }
};

export default adminApi;
